import { Alert, Grid, Group, Paper, Space, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import StepperButton from '../../../buttons/stepper.button/stepper.button';
import RepresentativeEscalationInformation from '../business-form-components/representative-information.component';
import SettlementDetails from '../business-form-components/settlement-details.component';
import UploadDocuments from '../business-form-components/upload-documents.component';
import { AlertCircle, X } from 'tabler-icons-react';

function BusinessStarterForm(props: {
  form: any;
  mainForm: any;
  active: number;
  nextStep: () => void;
  prevStep: () => void;
}) {
  const { form, mainForm, active, prevStep, nextStep } = props;
  const [loading, setLoading] = useState(false);

  const handleNextStep = () => {
    const { idsOfValidSignatories, storePhoto, barangayBusinessPermit } =
      form.values;

    if (
      idsOfValidSignatories.length === 0 ||
      storePhoto.length === 0 ||
      barangayBusinessPermit.length === 0
    ) {
      showNotification({
        id: 'failed-to-move-next-step',
        message: 'Incomplete files',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });

      return;
    }

    setLoading(true);
    mainForm.setValues(form.values);
    setLoading(false);
    if (!loading) nextStep();
  };

  const handlePrevStep = () => {
    setLoading(true);
    mainForm.setValues(form.values);
    form.clearErrors();
    setLoading(false);
    if (!loading) prevStep();
  };

  return (
    <>
      <form onSubmit={form.onSubmit(handleNextStep)}>
        <Grid mb={15}>
          <Grid.Col>
            <Title order={1}>Business Information</Title>
          </Grid.Col>
          <Grid.Col>
            <Title order={2} style={{ fontWeight: 500 }}>
              Business Starter
            </Title>
          </Grid.Col>
        </Grid>
        <Paper className='general-info-step' p={25} shadow='md' withBorder>
          <Grid>
            <Grid.Col>
              <RepresentativeEscalationInformation form={form} />
            </Grid.Col>
            <Grid.Col>
              <SettlementDetails form={form} />
            </Grid.Col>
            <Grid.Col>
              <UploadDocuments
                form={form}
                businessTypeId={form.values.businessTypeId}
              />
            </Grid.Col>
          </Grid>
        </Paper>
        <Group
          style={{ width: '100%' }}
          grow
          position='apart'
          align='flex-start'
          mt={30}
        >
          {Object.keys(form.errors).length > 0 ? (
            <Alert
              icon={<AlertCircle size={16} />}
              title='Invalid fields'
              color='red'
              variant='outline'
            >
              Please check fields for errors
            </Alert>
          ) : (
            <Space />
          )}
          <StepperButton
            prevStep={handlePrevStep}
            active={active}
            submit
            nextStep={undefined}
            loading={loading}
          />
        </Group>
      </form>
    </>
  );
}

export default BusinessStarterForm;
